import { useEffect, useState } from "react";
import { db } from "../services/firebase";
import { ref, onValue } from "firebase/database";

export default function useFetchCategoryQuestions(domainId, categoryId) {

    const [questions, setQuestions] = useState([]);
    const [loadingQuestions, setLoading] = useState(true);

    useEffect(() => {

        if (!domainId) { 
            return;
        }

        if (!categoryId) {
            return;
        }

        const questionsRef = ref(db, `Questions/CategoryQuestions/${domainId}/${categoryId}`);

        const unsubscribe = onValue(questionsRef, (snapshot) => {

            const data = snapshot.val();

            if (data) {
                const arr = Object.entries(data).map(([id, value]) => ({
                    id,
                    ...value,
                }));
                arr.sort((a, b) => (a.orderId || 0) - (b.orderId || 0));
                setQuestions(arr);
            } else {
                setQuestions([]);
            }
            setLoading(false);

        });

        return () => unsubscribe();
        
    }, [domainId, categoryId]);

    return { questions, loadingQuestions };
}
